import React, { useState } from "react";

import { withStyles } from "@mui/styles";
import {
  Box,
  Stack,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useStyles } from "../indexFormStyles";

function CustomStepper({ activeStep: id }) {
  const steps = [
    {
      label: "Plan Your Investment",
      description: [],
    },
    {
      label: "Get a Health Assessment",
      description: [],
    },
    {
      label: "KYC Verification",
      description: [],
    },
    {
      label: "Application Form Details",
      description: [],
    },
    {
      label: "Review Details",
      description: [],
    },
    {
      label: "Payment and Insta Confirmation",
      description: [],
    },
  ];

  const [activeStep, setActiveStep] = useState(Number(id));

  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map((step, index) => (
        <Step key={step.label}>
          <StepLabel>{step.label}</StepLabel>
          <StepContent>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="left"
              textAlign="left"
              flexDirection="row"
            >
              {step.description.map((item) => {
                return (
                  <Stack
                    direction="row"
                    gap={6}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Typography variant="caption">{item}</Typography>
                  </Stack>
                );
              })}
            </Box>
          </StepContent>
        </Step>
      ))}
    </Stepper>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomStepper);
